<template>

<section>
  <HomeSectionTitle>
    <template v-slot:title>
      for Image
    </template>
    <template v-slot:copy>
      이미지를 분석해서 이미지에 알맞은 단어를 달아주고,<br>
      이미지 내 객체에 대한 위치를 나타내는 APIs입니다.
    </template>
  </HomeSectionTitle>
  <HomeCards :cards="cards" :scrollName="'images'" class="cards-images"/>
</section>

</template>

<script>
import HomeSectionTitle from './HomeSectionTitle'
import HomeCards from './HomeCards'

import {getImageItems} from '@/tree'

export default {
  data() {
    return {
      cards: getImageItems()
    }
  },
  components: {
    HomeSectionTitle,
    HomeCards,
  }
}

</script>

<style lang="scss" scoped>
.cards-images {
  margin-top: 68px;
  margin-bottom: 100px;
}
</style>